import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=563c495f&"
import script from "./layout.vue?vue&type=script&lang=ts&"
export * from "./layout.vue?vue&type=script&lang=ts&"
import style0 from "./layout.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports